import Session from "../auth/Session";

export async function generateNmDocument(quoteId, documentType, delaySeconds = 0) {
    if (!quoteId) return;

    const token = Session.getToken();

    const response = await fetch('api/Document/GenerateNmDocument', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({
            QuoteId: quoteId,
            DocumentType: documentType,
            DelaySeconds: delaySeconds,
        }),
    });

    if(!response.ok) {
        throw new Error(`GenerateNmDocument (${documentType}) failed: ${response.status}`);
    }

    return response.json();
}